import React from 'react'

const Imagepopup = ({ imageUrls, onClose }) => {
    return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/80 backdrop-blur-sm" onClick={onClose}>
    <div className="relative max-h-full max-w-2xl p-8 rounded-2xl" onClick={(e) => e.stopPropagation()}>
            <button
                onClick={onClose}
                className="absolute top-2 right-6 text-white text-lg cursor-pointer hover:text-cyan-400 transition-colors z-10"
                >
          ✕
        </button>
      <div className="relative max-w-4xl max-h-96 overflow-auto custom-scrollbar p-4 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-md">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mx-auto">
          {imageUrls.map((imageUrl, index) => (
            <div key={index} className="rounded-xl overflow-hidden">
              <img
                src={imageUrl}
                alt={`Project screenshot ${index + 1}`}
                className="w-full h-auto rounded-xl hover:scale-105 transition-transform duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
    );
}

export default Imagepopup
